import * as english from "./locale-en.json";
// Reduce bundle size
// TODO add in babel plugin
import get from "lodash/get";
import template from "lodash/template";
import templateSettings from "lodash/templateSettings";
import { localeEvent } from "@mp/communication";
import parse, { domToReact } from "html-react-parser";
import DOMPurify from "dompurify";
import ReactDOMServer from "react-dom/server";

// Use lodash get to find value
let lang = "en";
let langFileLocale = "en";
let locale = {
  en: english,
};

function formatLangCode(lang: string) {
  if (lang.indexOf("_") > -1) {
    var langCode = lang.split("_")[0].toLowerCase();
    var variation = lang.split("_")[1].toUpperCase();
    return `${langCode}_${variation}`;
  }
  return lang.toLowerCase();
}

function formatLangFileLocale(formattedLang: string) {
  if (formattedLang.indexOf("-") > -1) {
    var langCode = formattedLang.split("-")[0].toLowerCase();
    var variation = formattedLang.split("-")[1].toUpperCase();
    return `${langCode}_${variation}`;
  }
  return formattedLang;
}

function applyTemplate(translation: string, values?: any): string {
  const compiled = template(translation, { interpolate: /{{([\s\S]+?)}}/g });
  try {
    const cleanHtmlString = DOMPurify.sanitize(compiled(values || {}), {
      USE_PROFILES: { html: true },
      ADD_ATTR: ["target"],
    });
    return cleanHtmlString;
  } catch (e) {
    console.error(e);
    return translation;
  }
}

export function t(key: string, fallback?: string, values?: any): string {
  let translation = get(locale, `${lang}.${key}`, fallback);
  if (translation) {
    return applyTemplate(translation, values);
  }

  // If no english translation, return conspicous string
  translation = get(locale, `en.${key}`, fallback || `???${key}???`);
  return applyTemplate(translation, values);
}

export function tReact(
  key: string,
  fallback?: string,
  values?: any
): ReturnType<typeof domToReact> {
  return parse(t(key, fallback, values));
}

export function tCut(key: string, offset: number): string {
  const pieces = t(key).split("|");
  if (pieces.length > 1) {
    return t(key).split("|")[offset];
  }
  return t(key);
}

export function getLocale() {
  return locale;
}

// TODO: test with multiple MFEs
// Import english always. Then import and set a different language
export function setLanguage(language: string) {
  lang = formatLangCode(language);
  langFileLocale = formatLangFileLocale(lang);
  import(`./locale-${langFileLocale}.json`)
    .then((data: any) => {
      locale[lang] = data.default;
      localeEvent.broadcast(lang);
    })
    .catch(() => {
      console.error(
        `Failed to import ./locale-${langFileLocale}.json; ${language} is not supported. Will use English fallback.`
      );
      // Add empty object. Since no translation exists, it will fallback to english.
      locale[lang] = {};
      localeEvent.broadcast(lang);
    });
}

export function getLanguage() {
  return lang;
}
